import { createI18n } from 'vue-i18n'
import localesEn from '@/locales/en.json'
import localesRo from '@/locales/ro.json'
import localesRu from '@/locales/ru.json'

const i18n = createI18n({

    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: {
        en: localesEn,
        ru: localesRu,
        ro: localesRo,
    },
})

export default i18n


